import type { Subtask, TaskStatus } from '@/lib/types'

// Subtask RUTIN (repetitif) tidak ikut menentukan status/penyelesaian task induk.
const countable = (subtasks: Subtask[]): Subtask[] => subtasks.filter((s) => !s.recurrence)

export function getEffectiveStatus(subtasks: Subtask[]): TaskStatus {
  const subs = countable(subtasks)
  if (subs.length === 0) return 'not-started'
  if (subs.every((s) => s.completed)) return 'done'
  return 'in-progress'
}

// Status efektif sebuah task:
//  - PUNYA subtask (non-rutin) → diturunkan dari subtask (otomatis).
//  - TANPA subtask non-rutin    → pakai status manual task (checkbox/cycle).
export function effectiveTaskStatus(taskStatus: TaskStatus, subtasks: Subtask[]): TaskStatus {
  const subs = countable(subtasks)
  if (subs.length === 0) return taskStatus
  if (subs.every((s) => s.completed)) return 'done'
  return 'in-progress'
}

export function cn(...classes: (string | undefined | false | null)[]): string {
  return classes.filter(Boolean).join(' ')
}

export function generateId(): string {
  return Math.random().toString(36).substring(2, 11)
}

export function formatDate(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

// PIC avatar color derived from name
const PIC_PALETTE = ['#6366F1','#F59E0B','#16A34A','#EF4444','#8B5CF6','#EC4899','#14B8A6','#F97316']
export function picColor(name: string): string {
  let h = 0; for (let i = 0; i < name.length; i++) h += name.charCodeAt(i)
  return PIC_PALETTE[h % PIC_PALETTE.length]
}

export const PROJECT_COLORS = [
  '#D4A843',
  '#22D3EE',
  '#A78BFA',
  '#34D399',
  '#F87171',
  '#FB923C',
  '#60A5FA',
  '#F472B6',
]

// PIC disimpan di SATU kolom `assignee` sebagai nama-nama yang digabung ';'
// (mis. "Dimas;Miqdam"). Berlaku untuk task maupun subtask. Dipakai bersama agar
// pemecahan dan normalisasinya tidak ditulis ulang beda-beda di tiap layar —
// perbedaan kecil di situ dulu membuat orang kedua di daftar tidak terlihat.
export function parsePics(raw: string | null | undefined): string[] {
  if (!raw) return []
  const seen = new Set<string>()
  const out: string[] = []
  for (const part of raw.split(';')) {
    const v = part.trim()
    if (v && !seen.has(v.toLowerCase())) { seen.add(v.toLowerCase()); out.push(v) }
  }
  return out
}

/** Gabung daftar PIC kembali ke bentuk simpan. Kosong → null (bukan ''). */
export function joinPics(names: string[]): string | null {
  const list = parsePics(names.join(';'))
  return list.length ? list.join(';') : null
}

/** True kalau `username` ada di daftar PIC (bandingkan case-insensitive, abaikan spasi). */
export function isPic(raw: string | null | undefined, username: string | null | undefined): boolean {
  const me = (username ?? '').trim().toLowerCase()
  if (!me) return false
  return parsePics(raw).some((n) => n.toLowerCase() === me)
}
